import React, {useState, useRef, useEffect, useContext} from "react";
import {
  Button,
  IconButton,
  Input,
  Stack,
  Typography,
  Modal,
} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {Cancel01Icon, PhoneCallIcon} from "@hugeicons/core-free-icons";
import { DialAtom } from "../../atoms";
import { useAtom } from "jotai";
import {lightGreen} from "@mui/material/colors";
import {ConversationRepository} from "../../../../repositories/ConversationRepository";
import {toast} from "react-toastify";
import {SignInContext} from "../../../../context/SignInContext";
import useCallConfirm from "../../../../hooks/useCallConfirm";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 360,
  width: "90%",
  bgcolor: "background.paper",
  borderRadius: 4,
  boxShadow: 24,
  px: 4, py: 3,
  overflowY: "auto",
};

const dialButtons = [
  ["1", "2", "3"],
  ["4", "5", "6"],
  ["7", "8", "9"],
  ["*", "0", "#"],
];

export const DialModal = ({project}) => {
  const {currentUser} = useContext(SignInContext);
  const [open, setOpen] = useAtom(DialAtom);
  const [phoneNumber, setPhoneNumber] = useState("");
  const inputRef = useRef(null);
  const confirm = useCallConfirm(
    'Do you want to initiate conversation',
  );

  useEffect(() => {
    if (open && inputRef.current) {
      inputRef.current.focus();
    }
  }, [open, inputRef?.current]);

  const onClose = () => {
    setOpen(false);
    setPhoneNumber("");
  };

  const handleDial = (digit) => {
    setPhoneNumber((prev) => prev + digit);
  };

  const initiateConversation = async (e) => {
    e?.stopPropagation();
    e?.preventDefault();

    const agentVdn = currentUser?.username ? project?.vdnManager[currentUser?.username] || null : null;
    console.log(agentVdn, phoneNumber)
    if (agentVdn && phoneNumber) {
      const body = {username: currentUser?.username, vdn: agentVdn, phone_number: phoneNumber, initiate_call_api: project?.configuration?.initiate_call_api};
      const params = {flow_uid: project?.id};

      const response = await confirm({title: `Do you want to initiate conversation with ${body?.phone_number}`})
      if (response) {
        ConversationRepository.initiateConversation({body, params})
          .then(response => {
            toast.success(response?.data?.message || `Initiated conversation with ${body?.phone_number}`);
          })
          .catch(error => {
            toast.error(error?.message || `Failed to initiated conversation with ${body?.phone_number}`);
          })
      }
    }
  }

  return (
    <Modal open={open} onClose={onClose}>
      <Stack sx={style} gap={2}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" fontWeight={600}>Dial a Number</Typography>
          <IconButton onClick={onClose}>
            <HugeiconsIcon icon={Cancel01Icon} />
          </IconButton>
        </Stack>

        <Input
          inputRef={inputRef}
          autoFocus disableUnderline
          type={"text"}
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          placeholder="Enter phone number"
          fullWidth
          inputProps={{sx: { textAlign: "center" }, autoFocus: true}}
          sx={{ fontSize: "1.5rem", textAlign: "center" }}
        />

        <Stack spacing={1} alignItems="center">
          {dialButtons.map((row, i) => (
            <Stack key={i} direction="row" spacing={2}>
              {row.map((digit) => (
                <Button
                  key={digit} color={"secondary"}
                  onClick={() => handleDial(digit)}
                  sx={{
                    width: 64,
                    height: 64,
                    borderRadius: "50%",
                    fontSize: "1.5rem",
                    backgroundColor: "#f0f0f0",
                  }}
                >
                  {digit}
                </Button>
              ))}
            </Stack>
          ))}
        </Stack>

        <Stack direction="row" justifyContent="center" mt={2}>
          <Button
            onClick={initiateConversation}
            sx={{
              backgroundColor: "#67bc60",
              color: "white",
              width: '90%',
              height: 48,
              borderRadius: 5,
              "&:hover": { backgroundColor: "#569c50" },
            }}
            startIcon={
              <HugeiconsIcon icon={PhoneCallIcon} size={32} />
            }
          >
            Make a Call
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
};
